import { AfterViewInit, Directive, ElementRef, EventEmitter, OnDestroy, Output } from "@angular/core";

/** Put on a 1px element right after the sticky bar. Observed, not read off the scroll container: inside `ui-right-panel` that element belongs to `@flowtribe/ui`. */
@Directive({
  selector: "[uiStickySentinel]",
  standalone: false
})
export class StickySentinelDirective implements AfterViewInit, OnDestroy {
  @Output() stuckChange = new EventEmitter<boolean>();

  private observer: IntersectionObserver | null = null;
  private isStuck: boolean | null = null;

  constructor(private readonly elementRef: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    this.observer = new IntersectionObserver(
      entries => {
        // Only the latest entry matters; a batch is just intermediate positions of one scroll.
        const stuck = !entries[entries.length - 1].isIntersecting;
        if (stuck !== this.isStuck) {
          this.isStuck = stuck;
          this.stuckChange.emit(stuck);
        }
      },
      { threshold: 0 }
    );
    // `observe` fires once immediately, which is what sets the initial state.
    this.observer.observe(this.elementRef.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
    this.observer = null;
  }
}
